class RefinanceController {
  constructor(NumberService) {
    this.name = 'refinance';
    this.NumberService = NumberService;
    this.matterType = 'mortgage_refinancing';
    this.stepSelector = 'refinance-steps';
    this.pages = [
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'AMOUNT',
        fields: [
          {
            fieldName: 'What is your new mortgage amount?',
            field: 'amount',
            type:'currency',
            required: true,
            value: "0.00",
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'amount');
              // valid when amount is defined and it is greater than 0
              return typeof x.value !== 'undefined' && this.NumberService.parseDecimal(x.value) > 0;
            }
           }
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'EXISTING MORTGAGES',
        fields: [
          {
            fieldName: 'Are you paying off an existing mortgage?',
            field: 'existingMortgage',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'existingMortgage');
              // valid when existingMortgage is defined
              return typeof x.value !== 'undefined';
            }
          },
          {
            fieldName: 'How many mortgages will you be paying off?',
            field: 'numExistingMortgages',
            type:'number',
            required: true,
            smallField: true,
            value: 1,
            min: 1,
            max: 5,
            hide: (fields) => {
              // hides this field when the the hasMortgage field is not defined or is false
              let x = fields.find(x => x.field === 'existingMortgage');
              return typeof x.value === 'undefined' || !x.value;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'numExistingMortgages');
              let y = fields.find(x => x.field === 'existingMortgage');
              // is valid if existingMortgage is false or if numExistingMortgages is defined and is greater than 0
              return !y.value || (x.value != null && x.value > 0);
            },
            invalidText: 'Value must be greater than 0'
          },

          {
            fieldName: 'Total Outstanding Amount of Mortgage(s) being Paid Off',
            field: 'totalExistingMortgages',
            type:'currency',
            required: true,
            smallField: true,
            value: "$0.00",
            hide: (fields) => {
              // hides this field when the the hasMortgage field is not defined or is false
              let x = fields.find(x => x.field === 'existingMortgage');
              return typeof x.value === 'undefined' || !x.value;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'totalExistingMortgages');
              let y = fields.find(x => x.field === 'existingMortgage');
              if (y.value){
                return typeof x.value !== 'undefined' && this.NumberService.parseDecimal(x.value) > 0;
              }
              else{
                return true;
              }
            }
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'DEBTS',
        fields: [
          {
            fieldName: 'Are any other debts being paid off?',
            field: 'debts',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
               let x = fields.find(x => x.field === 'debts');
               // valid when debts is defined
               return typeof x.value !== 'undefined';
             }
          },
          {
            fieldName: 'How many other debts will be paid off?',
            field: 'numDebts',
            type:'number',
            required: true,
            smallField: true,
            value: 1,
            min: 1,
            max: 5,
            hide: (fields) => {
              // hides this field when the the hasMortgage field is not defined or is false
              let x = fields.find(x => x.field === 'debts');
              return typeof x.value === 'undefined' || !x.value;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'numDebts');
              let y = fields.find(x => x.field === 'debts');
              // is valid if debts is false or if numDebts is defined and is greater than 0
              return !y.value || (x.value != null && x.value > 0);
            }
          },

          {
            fieldName: 'Total Amount of other debts being Paid Off',
            field: 'totalDebts',
            type:'currency',
            required: true,
            smallField: true,
            value: "$0.00",
            hide: (fields) => {
              // hides this field when the the hasMortgage field is not defined or is false
              let x = fields.find(x => x.field === 'debts');
              return typeof x.value === 'undefined' || !x.value;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'totalDebts');
              let y = fields.find(x => x.field === 'debts');
              // valid when totalDebts is not undefined
              if (y.value){
              return typeof x.value !== 'undefined' && this.NumberService.parseDecimal(x.value) > 0;
              }
              else{
                return true;
              }
            }
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'EMAIL',
        type:'email', // defines the type of page ( regular, email, end ). The default value is regular
        fields: []
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'CLOSING COST',
        type:'done', // defines the type of page ( regular, email, end ). The default value is regular
        fields: []
      }
    ];
  }

  goTo(x) {
    this.page = x;
  }

  getState(){
    console.log(this);
  }
}

RefinanceController.$inject = ['NumberService'];

export default RefinanceController;



// WEBPACK FOOTER //
// ./client/app/components/refinance/refinance.controller.js